import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getFlight: (state) => (date) => {
    return state.all.flights.find(datum => (datum.from === undefined || parseInt(datum.from, 10) <= parseInt(date.replace(/-/g, ''), 10)) && (datum.to === undefined || parseInt(datum.to, 10) >= parseInt(date.replace(/-/g, ''), 10)));
  }
}

const actions = {
  fetchAll ({ commit }) {
    return new Promise((resolve) => {
      api.getFlights()
        .then(data => {
          commit('setFlightData', data)
          resolve()
        })
        .catch(() => {
          commit('resetState')
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setFlightData (state, data) {
    state.all = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
